import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';

import {AudienceTargeting} from 'client/common/utils/audience';
import I18N from 'assets/i18n/brandlift-project';

import {
    AudienceCategoryInfo,
    AudienceInterestInfo,
    AudienceRequest,
    AudienceSegmentInfo,
    Resource,
    Survey,
    Creative as CreativeData,
    VHVideoState,
    BordomatikBox,
    CreativeBox
} from 'client/common/types';

import {Creative} from '../types';

const i18n = I18N.creatives.utils.parse;

interface ParseCreativeParams {
    audience: AudienceRequest;
    categories: AudienceCategoryInfo[];
    interests: AudienceInterestInfo[];
    segments: AudienceSegmentInfo[];
}

export interface CreativeInfo extends CreativeData {
    state?: VHVideoState;
}
export function getCreativeInfo(box: Survey['box'], resources: Resource[]): CreativeInfo {
    let creativeInfo = cloneDeep(get(box, ['context', 'creative'])) || {};
    const resource = resources.find(({id, type}) => id === creativeInfo.id && type === 'vh_video');

    if (creativeInfo.service === 'resource') {
        creativeInfo = {
            ...creativeInfo,
            id: resource?.resourceData.shortId,
            state: resource?.resourceData.state ?? 'new'
        };
    } else {
        creativeInfo.state = 'ready';
    }

    return creativeInfo;
}

export function getAdditionalParameters(
    box: CreativeBox | BordomatikBox
): Creative['additionalParameters'] {
    return Object.entries(get(box, ['context', 'optionalQuestions'], {}))
        .filter(([, isEnabled]) => isEnabled)
        .map(
            ([param]) =>
                i18n.additionalParameter[param as 'story' | 'heroes' | 'packshots' | 'slogans'] ||
                ''
        )
        .filter(Boolean)
        .join(', ');
}

export function getCreativeTargeting(params: ParseCreativeParams): string {
    const {audience, categories, interests, segments} = params;

    return AudienceTargeting.formatAsString({request: audience, categories, interests, segments}) || '';
}
